import { render, staticRenderFns } from "./boosting-feature-container.component.vue?vue&type=template&id=640ff4f8&scoped=true"
import script from "./boosting-feature-container.component.vue?vue&type=script&lang=ts"
export * from "./boosting-feature-container.component.vue?vue&type=script&lang=ts"
import style0 from "./boosting-feature-container.component.vue?vue&type=style&index=0&id=640ff4f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ff4f8",
  null
  
)

export default component.exports